// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__2vy4Q","path":"style_path__2-FFw","arrow":"style_arrow__1zrDI"};